import { CircularProgress } from "@mui/material";
import "./styles.css";

function Loader() {
    return (
        <div className="loaderContainer">
            <CircularProgress style={{ opacity: 1, zIndex: 2000000 }} />
        </div>
    );
}

export default Loader;
